import { LoadingOutlined } from '@ant-design/icons';
import { css } from '@linaria/core';
import { Flex, Spin } from 'antd';

const styles = {
  loading: css`
    min-height: 300px;
    width: 100%;
  `,
};

const ContentLoading = () => (
  <Flex
    className={styles.loading}
    align="center"
    justify="center"
    role="status"
    aria-label="Carregando conteúdo"
  >
    <Spin indicator={<LoadingOutlined spin />} />
  </Flex>
);

export default ContentLoading;
